module.exports = __webpack_public_path__ + "img/hr-red-croton-03.d5d91d45.png";